import * as React from "react";
import { typeCompact14Regular } from "@traceair/tds";
import { classes, stylesheet } from "typestyle";
import config from "../../../config";
import SidebarHeader from "../../Generics/SidebarHeader";
import useCurrentGcpRequestState from "../currentGCPRequestStore";

export interface IProps {
  rightIcon?: React.ReactNode;
  onRightIconClick?: () => void;
}

const dtOptions: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "short",
};

const dtLocale = config.language === "ru" ? "ru-RU" : "en-US";

export const GCPRequestSidebarHeader: React.FC<IProps> = ({
  rightIcon,
  onRightIconClick,
}: IProps) => {
  const createdAt = useCurrentGcpRequestState(
    ({ GCPRequest }) => GCPRequest?.createdAt,
  );

  let fullText =
    config.language === "ru"
      ? "Карта опознаков (нет текущего GCP-запроса)"
      : "Flight Markers Map (no current GCP request)";

  if (createdAt) {
    const text =
      config.language === "ru" ? "GCP запрос от" : "GCP request from";
    const dt = new Date(createdAt);

    fullText = `${text} ${new Intl.DateTimeFormat(dtLocale, dtOptions).format(
      dt,
    )}`;
  }

  return (
    <SidebarHeader
      leftLabel={
        <div className={classes(typeCompact14Regular, css.label)}>
          {fullText}
        </div>
      }
      rightIcon={rightIcon || null}
      onRightIconClick={onRightIconClick || null}
    />
  );
};

const css = stylesheet({
  label: {
    color: "#FFFFFF",

    whiteSpace: "normal",
  },
});
